export const SUPPORT_EMAIL = 'support@goparkingnow.com'
export const PRIVACY_EMAIL = 'privacy@goparkingnow.com'
export const COMPANY_NAME = 'SAS NEXIA MOBILE'
export const WEBSITE_URL = 'goparkingnow.com'
// Identifiant de l'app (DB Supabase partagée par plusieurs apps parking).
// Sert à scoper les relances email par app. À changer si ce code est
// resynchronisé vers une autre app (ex. parkingbolt).
export const APP_ID = 'goparkingnow'
